var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NOTIFICATION-LINK",class:{'HAS-NEW-NOTIFICATIONS': _vm.hasNewNotifications },attrs:{"selenium":"header-notification-link"}},[_c('vk-icon',{staticClass:"h4",attrs:{"name":"bell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }